import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const cached = localStorage.getItem("hr_user");
      return cached ? JSON.parse(cached) : null;
    } catch (_) { return null; }
  });
  const [loading, setLoading] = useState(true);

  const persistUser = (u) => {
    if (u) localStorage.setItem("hr_user", JSON.stringify(u));
    else localStorage.removeItem("hr_user");
    setUser(u);
  };

  const refreshMe = async () => {
    const token = localStorage.getItem("hr_token");
    if (!token) {
      persistUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      persistUser(data);
    } catch (e) {
      localStorage.removeItem("hr_token");
      persistUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshMe();
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("hr_token", data.token);
      persistUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const register = async (email, password, name) => {
    try {
      const { data } = await api.post("/auth/register", { email, password, name });
      localStorage.setItem("hr_token", data.token);
      persistUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("hr_token");
    persistUser(null);
  };

  const updateProfile = async (payload) => {
    try {
      const { data } = await api.put("/auth/me", payload);
      persistUser(data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, updateProfile, refreshMe }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
